import { render } from "./RecentDecks.vue?vue&type=template&id=67cf03f7"
import script from "./RecentDecks.vue?vue&type=script&lang=js"
export * from "./RecentDecks.vue?vue&type=script&lang=js"

import "./RecentDecks.vue?vue&type=style&index=0&id=67cf03f7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__